const data = {
  "company": {
    "name": "ViSRUPT",
    "founded": 2019,
    "headquarters": "Pune, India",
    "contact": {
      "email": "contact@visrupt.in",
      "phone": "+91 7522979568"
    },
    "technologies": {
      "languages": ["Python", "JavaScript", "TypeScript"],
      "frameworks": ["React", "Node.js", "FastAPI"],
      "tools": ["Docker", "Git", "AWS"],
      "databases": ["PostgreSQL", "MongoDB", "Redis"]
    },
    "metrics": {
      "clientSatisfaction": "98%",
      "projectsCompleted": 235,
      "activeClients": 156,
      "teamSize": 6
    }
  }
};

const SecretData = () => <pre>{JSON.stringify(data, null, 2)}</pre>;

export default SecretData;